var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "authWrapper new-login-wrapper rest-password-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row whiteBG-wrap login-white-wrap"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-7 no-padding"
  }, [_c('div', {
    staticClass: "login-left-wrap"
  }, [_c('router-link', {
    attrs: {
      "to": "/verify-details"
    }
  }, [_c('h6', {
    staticClass: "login-highlight"
  }, [_vm._v("Back")])]), _vm._m(0), _c('h4', {
    staticClass: "login-title mb-2"
  }, [_vm._v("Register to Member Dashboard")]), _c('div', {
    staticClass: "auth-form pt-1 pb-3"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('b-form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return handleSubmit(_vm.changePassword);
            }
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Email",
            "label-for": "input-1"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "input-1",
            "type": "text",
            "required": "",
            "placeholder": "Enter your email",
            "readonly": ""
          },
          model: {
            value: _vm.memberemail,
            callback: function callback($$v) {
              _vm.memberemail = $$v;
            },
            expression: "memberemail"
          }
        }), _vm.formErrorFlag == true ? _c('div', {
          staticClass: "error_message"
        }, [_vm._v(" " + _vm._s(_vm.formErrors["email"]) + " ")]) : _vm._e()], 1), _c('ValidationProvider', {
          attrs: {
            "rules": "required",
            "name": "New Password",
            "vid": "newpassword"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref2) {
              var valid = _ref2.valid,
                errors = _ref2.errors;
              return _c('b-form-group', {
                staticClass: "mb-0",
                attrs: {
                  "label": "New Password",
                  "label-for": "input-1"
                }
              }, [_c('div', {
                staticClass: "changeForm-group errorIcon_eye position-relative"
              }, [_c('b-form-input', {
                staticClass: "no-bg-icon",
                attrs: {
                  "id": "input-1",
                  "type": _vm.newPasswordType,
                  "state": errors[0] || _vm.formErrorFlag ? false : valid ? true : null,
                  "placeholder": "Enter your new password"
                },
                on: {
                  "input": _vm.onPasswordInput
                },
                model: {
                  value: _vm.newpassword,
                  callback: function callback($$v) {
                    _vm.newpassword = $$v;
                  },
                  expression: "newpassword"
                }
              }), _c('eye-form-button', {
                staticClass: "rest-toggle-eye-icon",
                attrs: {
                  "id": "newpassword",
                  "hideOnDefault": "false",
                  "value": _vm.newpassword,
                  "type": "text"
                },
                on: {
                  "toggle": _vm.toggleNewPasswordVisibility
                }
              }), _c('b-form-invalid-feedback', [errors[0] ? _c('div', [_vm._v(" Please enter your new password ")]) : _vm._e(), _vm.formErrorFlag == true ? _c('div', {
                staticClass: "error_message"
              }, [_vm._v(" " + _vm._s(_vm.formErrors["error"]) + " ")]) : _vm._e()])], 1)]);
            }
          }], null, true)
        }), _c('b-form-group', {
          staticClass: "mb-0",
          attrs: {
            "label": " ",
            "label-for": ""
          }
        }, [_c('div', [_c('password-strength-bar', {
          attrs: {
            "password": _vm.newpassword
          },
          on: {
            "updateScore": _vm.setPasswordScore
          }
        })], 1)]), _c('ValidationProvider', {
          attrs: {
            "rules": "required|confirmed:newpassword",
            "name": "Re-Type New Password"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref3) {
              var valid = _ref3.valid,
                errors = _ref3.errors;
              return _c('b-form-group', {
                attrs: {
                  "label": "Re-Type New Password",
                  "label-for": "input-2"
                }
              }, [_c('div', {
                staticClass: "changeForm-group position-relative",
                class: errors[0] || valid ? 'errorIcon_eye' : ''
              }, [_c('b-form-input', {
                staticClass: "no-bg-icon",
                attrs: {
                  "id": "input-2",
                  "type": _vm.reTypePasswordType,
                  "state": errors[0] || _vm.formErrorFlag ? false : valid ? true : null,
                  "placeholder": "Re-Type New Password"
                },
                model: {
                  value: _vm.confirmpassword,
                  callback: function callback($$v) {
                    _vm.confirmpassword = $$v;
                  },
                  expression: "confirmpassword"
                }
              }), _c('eye-form-button', {
                staticClass: "rest-toggle-eye-icon",
                attrs: {
                  "id": "reTypepassword",
                  "hideOnDefault": "false",
                  "value": _vm.confirmpassword,
                  "type": "text"
                },
                on: {
                  "toggle": _vm.toggleReTypePasswordVisibility
                }
              }), _c('b-form-invalid-feedback', [_c('div', [_vm._v(" Please reenter your new password ")]), _vm.formErrorFlag == true ? _c('div', {
                staticClass: "error_message"
              }, [_vm._v(" " + _vm._s(_vm.formErrors["error"]) + " ")]) : _vm._e()])], 1)]);
            }
          }], null, true)
        }), _c('button', {
          staticClass: "submit-btn mt-3 next-btn ml-0",
          attrs: {
            "disabled": _vm.verifyLoader,
            "type": "submit"
          }
        }, [_vm.verifyLoader ? _c('b-spinner', {
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" Save Password ")], 1)], 1)];
      }
    }])
  })], 1)], 1)]), _c('div', {
    staticClass: "col-lg-5 col-md-5 p-0"
  }, [_c('Logincarsoule')], 1)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rep-icon-login"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/member-login.svg"),
      "alt": "image-fluid"
    }
  })]);
}]

export { render, staticRenderFns }